import { ref } from 'vue'

/**
 * Exposes a monotonic `$hydrated` flag, flipped true once client hydration has
 * completed (ECOM-2692).
 *
 * Why a dedicated flag instead of `nuxtApp.isHydrating`: inside an async page's
 * `<script setup>`, `isHydrating` already reads `false` (it flips on
 * `app:suspense:resolve`, which fires before nested async pages finish
 * resolving — nuxt/nuxt#14839), and it is not reactive (nuxt/nuxt#25662). PLP
 * reconciliation (`usePlpNavigationReconcile`) needs a reliable, observable
 * "we are past hydration" signal to both gate and trigger on, so this plugin
 * owns one.
 *
 * Named generically (`$hydrated`, not PLP-specific) since it's a reusable
 * client-side signal. `app:suspense:resolve` can fire early when lazy
 * components are present (nuxt/nuxt#13542); reconciliation tolerates that
 * because its decision (`shouldReconcilePlp`) also requires the slice to be
 * empty + idle and dedupes against the in-flight first fetch.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const hydrated = ref(false)

  nuxtApp.hook('app:suspense:resolve', () => {
    // Monotonic: only ever false -> true.
    hydrated.value = true
  })

  return {
    provide: { hydrated },
  }
})
